import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";
import { setSessionData } from "../../cache";

function StudentcorrectionXI() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");

  const [loading, setLoading] = useState(false);

  // ---------------- SEARCH STATES ----------------
  const [candidateId, setCandidateId] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [rollNo, setRollNo] = useState("");

  // ---------------- PAGE LOAD ----------------
  useEffect(() => {
    if (!token) {
      navigate("/intermediate-admin");
    }

    const fetchPageLoadData11 = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PageloadRegistrationData_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = await response.json();

        if (result?.data) {
          const {
            blockList,
            casteList,
            districtList,
            divyangList,
            mediumList,
            religionList,
            stateList,
            coreSubjects,
            matri_BhasaSubjects,
            compulsorySubjects,
            additionaLl_Subjects,
            optionalSubjects,
            electiveSubjects,
            sessionList,
            noDataFoundSessionList,
          } = result.data;

          setSessionData("blockList", blockList);
          setSessionData("casteList", casteList);
          setSessionData("districtList", districtList);
          setSessionData("divyangList", divyangList);
          setSessionData("mediumList", mediumList);
          setSessionData("religionList", religionList);
          setSessionData("stateList", stateList);
          setSessionData("coreSubjects", coreSubjects);
          setSessionData("matri_BhasaSubjects", matri_BhasaSubjects);
          setSessionData("compulsory_Paper_2Subjects", compulsorySubjects);
          setSessionData("additional_Subjects", additionaLl_Subjects);
          setSessionData("optional_Paper_1_2Subjects", optionalSubjects);
          setSessionData("electivesubj", electiveSubjects);
          setSessionData("sessionlist", sessionList);
          setSessionData("noDataFoundSessionList", noDataFoundSessionList);
        }
      } catch (error) {
        console.error("Error in page load:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageLoadData11();
  }, [token, navigate]);

  // ---------------- INPUT HANDLERS ----------------

  const handleCandidateChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setCandidateId(value);

    if (value) {
      setSchoolCode("");
      setRollNo("");
    }
  };

  const handleSchoolCodeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setSchoolCode(value);

    if (value) {
      setCandidateId("");
    }
  };

  const handleRollNoChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setRollNo(value);
  };

  // ---------------- SEARCH ----------------
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!candidateId && !schoolCode && rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter School Code",
      });
      return;
    }
    if (!candidateId && schoolCode && !rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Roll No",
      });
      return;
    }
    if (!candidateId && !schoolCode) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Candidate ID OR School Code & Roll No",
      });
      return;
    }

    setLoading(true);

    try {
      const requestBody = candidateId
        ? { candidatE_ID: candidateId, schooL_CODE: null, rolL_NO: null }
        : { schooL_CODE: schoolCode, rolL_NO: rollNo, candidatE_ID: null };

      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchDataStudentRegistrationCandidateID_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();

      if (response.ok && data?.data?.student_Data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/intermediate-demographic-details-update-page-xi", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with the given details.",
        });
      }
    } catch (err) {
      console.error("API Error:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              {/* HEADER */}
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" />
                      Student Demographic Details Correction for Class XI
                    </h1>
                  </section>
                </div>
              </div>

              {/* SEARCH SECTION */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Candidate ID */}
                      <div className="col-md-3">
                        <label>Candidate ID</label>
                        <input
                          type="text"
                          className="form-control form-control-xs mt-2"
                          value={candidateId}
                          onChange={handleCandidateChange}
                          disabled={schoolCode !== ""}
                          maxLength={15}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      {/* School Code */}
                      <div className="col-md-2">
                        <label>School Code</label>
                        <input
                          type="text"
                          className="form-control form-control-xs mt-2"
                          value={schoolCode}
                          onChange={handleSchoolCodeChange}
                          disabled={candidateId !== ""}
                          maxLength={10}
                        />
                      </div>

                      {/* Roll No */}
                      <div className="col-md-2">
                        <label>Roll No</label>
                        <input
                          type="text"
                          className="form-control form-control-xs mt-2"
                          value={rollNo}
                          onChange={handleRollNoChange}
                          disabled={!schoolCode || candidateId !== ""}
                          maxLength={10}
                        />
                      </div>

                      {/* Search Button */}
                      <div className="col-md-2">
                        <button
                          className="btn btn-success"
                          style={{ marginTop: "30px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentcorrectionXI;
